<template lang="pug">
  .table-wrap
    table.table.js-table
      tr.table__row
        th.table__cell(
          v-for="(cell, index) in theadData"
        )
          .cell-content(
            v-if="cell.type !== 'empty'"
          )
            button.sorting.js-sorting(
              @click="sort(index, $event)"
              v-if="cell.enableSorting"
            ) {{ cell.text }}
            span.text(
              v-else
            ) {{ cell.text }}

      tr.table__row(
        v-show="tbodyData.length === 0"
      )
        td.table__cell()
          i Список пуст
      tr.table__row(
        v-show="tbodyData.length > 0"
        v-for="row in tbodyData"
      )
        td.table__cell(
          v-for="column in theadData"
          v-bind:class="{ 'table__cell_cut' : column.cut }"
        )
          .cell-content
            span.text(
              v-if="column.type === 'text'"
              :title="column.enableTitle ? row[column.key] : '' "
              :class="[column.enableClass ? `${row[column.class]}` : '']"
            ) {{ row[column.key] }}
            router-link.link(
              v-if="column.type === 'link'"
              :to="row[column.url]"
            ) {{ row[column.key] }}
            .dots(
              v-if="column.type === 'dots'"
            )
              button.dots__button
                span
                  .dots__dropdown
          //-   .status(
          //-     v-if="cell.type === 'status'"
          //-     :class="catalogue.orderStatuses[cell.status].value"
          //-   ) {{ catalogue.orderStatuses[cell.status].text }}
</template>

<script>
export default {
  name: "TableComponent",
  props: ["theadData", "tbodyData"],
  data() {
    return {
      allButton: [],
      classAscending: "sorting_ascending",
      classDescending: "sorting_descending"
    };
  },
  methods: {
    sort: function(index, $event) {
      var currentButton = $event.target;

      for (var i = 0; i < this.allButton.length; i++) {
        if (i !== index) {
          this.allButton[i].classList.remove(
            this.classAscending,
            this.classDescending
          );
        }
      }

      if (currentButton.classList.contains(this.classAscending)) {
        currentButton.classList.remove(this.classAscending);
        currentButton.classList.add(this.classDescending);
      } else if (currentButton.classList.contains(this.classDescending)) {
        currentButton.classList.remove(this.classDescending);
      } else {
        currentButton.classList.add(this.classAscending);
      }
    }
  },
  mounted() {
    var table = document.querySelector(".js-table");
    this.allButton = table.querySelectorAll(".js-sorting");
  }
};
</script>
